import { forwardRef } from 'react';
import type { PropsWithoutRef } from 'react';

import type { ForwardRefForwardPropsComponent } from '../../types';

import List from './List';
import type { ListProps } from './List';

const UnorderedList: ForwardRefForwardPropsComponent<ListProps> = forwardRef(function UnorderedList(
  props: PropsWithoutRef<ListProps>,
  ref: ListProps['ref']
) {
  return <List {...props} variant='unordered' ref={ref} />;
});

export default UnorderedList;
